import React from "react";
import MobileNav from "./MobileNav";

export default function Layout(props) {
  return (
    <>
      <div id="outer-container">
        <MobileNav />
        <main id="page-wrap" className={props.name}>
          {props.children}
        </main>
      </div>
    </>
  );
}
